/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthData, ManualItem } from './types'; // Mueve tus interfaces a un archivo types.ts
import AppRoutes from './routes';
import LoadingComponent from './components/LoadingComponent';
import { getManualRequest, modifyManualRequest, setManualRequest } from './api/employeePortal';

function App() {
  const [manualItems, setManualItems] = useState<ManualItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState<AuthData | null>(null);

  useEffect(() => {
    if (loading) return;
    getLoginData();
  }, []);

  useEffect(() => {
    if (loading || !loginData) return;
    fetchData();
  }, [loginData]);

  const getLoginData = () => {
    setLoading(true);
    const result = localStorage.getItem('loginData');
    if (result) {
      setLoginData(JSON.parse(result));
    }
    setLoading(false);
  };
  
  const fetchData = async () => {
    if (!loginData?.UserId) return;
    try {
      setLoading(true);
      const { data } = await getManualRequest(`${loginData?.UserId}`);
      setManualItems(data?.data?.items || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrEdit = async (data: any, mode: 'add' | 'edit') => {
    try {
      if (mode === 'add') {
        await setManualRequest(data);
      } else {
        await modifyManualRequest(data);
      }
      await fetchData();
    } catch (error) {
      console.error('Error saving data:', error);
      throw error;
    }
  };

  if (loading) {
    return <LoadingComponent loadingText="Cargando aplicación..." />;
  }

  return (
    <BrowserRouter>
      <AppRoutes 
        loginData={loginData}
        setLoginData={setLoginData}
        manualItems={manualItems}
        onAddOrEditManual={handleAddOrEdit}
        // setUpdateLoginData={setUpdateLoginData}
      />
    </BrowserRouter>
  );
}

export default App;